<template>
  <div>
    <Form  @submit.native.prevent="preventSubmit" inline>
      <FormItem label="查询：" :label-width="80">
        <Input type="text" v-model="packagingList.keyword" placeholder="查询关键字"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="queryWithKeyword">查询</Button>
      </FormItem>
      <FormItem>
        <Button @click="openUnbindRoomListModal" type="primary">新增打包</Button>
      </FormItem>
    </Form>
    <Table stripe :loading="packagingList.loading" height="450" :columns="packagingList.columns" :data="packagingList.data"></Table>
    <div style="margin: 10px;">
      <Page show-sizer placement="top" :total="packagingList.count" :current="packagingList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>

    <Modal v-model="unbindRoomListModal.display" ref="addPkgModal" :loading="true" :width="1100" title="未打包房间列表" @on-ok="prepareAddPkgRoomType" ok-text="确定打包" cancel-text="取消">
      <Form @submit.native.prevent="preventSubmit" inline>
        <FormItem  label="查询：" :label-width="60">
          <Input type="text" v-model="unbindRoomListModal.keyword" placeholder="查询关键字"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="queryModalDataWithKeyword">查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="selectedAll">全选</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="antiSelected">反选</Button>
        </FormItem>
      </Form>
      <Table stripe ref="unbindRoomListModalTable" :loading="unbindRoomListModal.loading" @on-selection-change="selectedChangeWithRow" :columns="unbindRoomListModal.columns" :data="unbindRoomListModal.displayData"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="unbindRoomListModal.count" :current="unbindRoomListModal.page" @on-page-size-change="changeModalPageSize" @on-change="changeModalPage"></Page>
      </div>
      <Row>
        <Col>{{`共${unbindRoomListModal.filterData.length}房，已选择${unbindRoomListModal.selectedRoomType.size}房`}}</Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import Utils from "@/utils";

export default {
  props: {
    unbindRoomList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.roomTypeId = Utils.getUrlParameterByName("roomTypeId");
  },
  data() {
    return {
      packagingList: {
        keyword: '',
        loading: false,
        columns: [
          {
            title: "楼宇ID",
            key: "buildingId",
            align: "center",
            width: 90
          },
          {
            title: "房间ID",
            key: "roomId",
            align: "center",
            width: 100
          },
          {
            title: "房间名称",
            key: "custRoomName",
            align: "center",
            width: 300
          },
          {
            title: "房型",
            key: "houseType",
            align: "center",
            width: 150
          },
          {
            title: "床型",
            key: "bedType",
            align: "center",
            width: 100
          },
          {
            title: "销售状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let status = "";
              switch(params.row.status) {
                case "S01":
                status = "上架";
                break;
                case "S02":
                status = "下架";
                break;
              }
              return h("div", {}, status);
            }
          },
          {
            title: "信息房",
            key: "infoRoom",
            align: "center",
            width: 150,
            render: (h, params) => {
              let status = params.row.isUnifyInfo == "N" ? "取信息" : "信息房";
              let element = params.row.isUnifyInfo == "N" ? "Button" : "div";
              let btnOption = {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定将此房间的信息详情设为房型信息？`;
                            return modalH("div", {
                              style: {
                                fontSize: "16px",
                              },
                            }, modalText)
                          },
                          onOk: () => {
                            this.activeRoomInfo(params.index);
                          }
                        })
                      }
                    }
                  }
              let option = params.row.isUnifyInfo == "Y" ? {} : btnOption;
              return h(element, option, status);
            }
          },
          {
            title: "是否取价",
            key: "isPrice",
            align: "center",
            width: 150,
            render: (h, params) => {
              let status = params.row.isUnifyPrice == "N" ? "取价" : "取价房";
              let element = params.row.isUnifyPrice == "N" ? "Button" : "div";
              let btnOption = {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定将此房间的价格设为房型标准价？`;
                            return modalH("div", {
                              style: {
                                fontSize: "16px",
                              },
                            }, modalText)
                          },
                          onOk: () => {
                            this.activeRoomPrice(params.index);
                          }
                        })
                      }
                    }
                  }
              let option = params.row.isUnifyPrice == "Y" ? {} : btnOption;
              return h(element, option, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        if (params.row.isUnifyInfo=="Y"||params.row.isUnifyPrice=="Y") {
                          this.$Notice.error({
                            title: "删除打包失败",
                            desc: "房间为信息房或取价房，不可删除打包！"
                          });
                          return;
                        }

                        this.preDelPackaging(params.row);
                      }
                    }
                  },
                  "删除打包"
                )
              ]);
            }
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      unbindRoomListModal: {
        display: false,
        keyword: '',
        loading: false,
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: "楼宇ID",
            key: "buildingId",
            align: "center",
            width: 90
          },
          {
            title: "楼层",
            key: "roomFloor",
            align: "center",
            width: 80
          },
          {
            title: "房间ID",
            key: "roomId",
            align: "center",
            width: 84
          },
          {
            title: "房间名称",
            key: "custRoomName",
            align: "center",
            width: 150
          },
          {
            title: "房号",
            key: "custRoomNo",
            align: "center",
            width: 150
          },
          {
            title: "房型",
            key: "roomTypeName",
            align: "center",
            width: 100
          },
          {
            title: "床数",
            key: "bedCount",
            align: "center",
            width: 84
          },
          {
            title: "面积",
            key: "area",
            align: "center",
            width: 84
          },
          {
            title: "销售状态",
            key: "flag",
            align: "center",
            width: 100
          },
          {
            title: "租赁类型",
            key: "tagCode",
            align: "center",
            width: 100
          }
        ],
        data: [],
        displayData: [],
        filterData: [],
        page: 1,
        pageSize: 10,
        count: 0,
        selectedRoomType: new Set()
      }

    }
  },
  methods: {
    queryWithKeyword() {

    },
    queryList() {

    },
    openUnbindRoomListModal() {
      this.initUnbindRoomListModal();

      this.unbindRoomListModal.display = true;

      this.$emit('openUnbindRoomListModal');
    },
    initUnbindRoomListModal() {
      this.unbindRoomListModal = Object.assign({}, this.unbindRoomListModal, {
        keyword: '',
        data: [],
        displayData: [],
        filterData: [],
        page: 1,
        pageSize: 10,
        count: 0,
        selectedRoomType: new Set()
      })
    },
    preDelPackaging(roomType) {
      this.$Modal.confirm({
        render: h => {
          let text = `确定取消打包此房间？该房间将恢复独立销售`;
          return h("div", {
            style: {
              fontSize: "16px",
            },
          }, text)
        },
        onOk: () => {
          // TODO: 删除打包
          console.info(roomType);
        }
      })
    },
    changePage(pageIndex) {
      this.packagingList.page = pageIndex;
      this.queryList();
    },
    changePageSize(pageSize) {
      this.packagingList.page = 1;
      this.packagingList.pageSize = pageSize;
      this.queryList();
    },
    // 查询未打包房间列表
    queryUnbindRoomList() {
      this.unbindRoomListModal.loading = true;
      let unbindRoomList = this.unbindRoomList;

      this.unbindRoomListModal.data = unbindRoomList;
      this.unbindRoomListModal.count = unbindRoomList.length;
      this.unbindRoomListModal.pageCount = (this.unbindRoomListModal.count % this.unbindRoomListModal.page) == 0 ? (this.unbindRoomListModal.count / this.unbindRoomListModal.page) : (this.unbindRoomListModal.count / this.unbindRoomListModal.page + 1)
      this.unbindRoomListModal.filterData = this.unbindRoomListModal.data;
      this.displayUnbindRoomList();
      this.unbindRoomListModal.loading = false;
    },
    // 展示当前页数的未打包房间
    displayUnbindRoomList() {
      let startIndex = (this.unbindRoomListModal.page-1) * this.unbindRoomListModal.pageSize;
      let endIndex = this.unbindRoomListModal.pageSize * this.unbindRoomListModal.page;
      this.unbindRoomListModal.displayData = [];

      let filterData = [];
      for (let i=startIndex; i<endIndex; i++) {
        if (!this.unbindRoomListModal.filterData[i]) break;
        filterData.push(this.unbindRoomListModal.filterData[i]);
      }
      this.unbindRoomListModal.displayData = filterData;
    },
    // 前端查询
    queryModalDataWithKeyword() {
      this.unbindRoomListModal.loading = true;
      this.unbindRoomListModal.filterData = this.filterModalDataWithKeyword();
      this.unbindRoomListModal.page = 1;
      this.unbindRoomListModal.count = this.unbindRoomListModal.filterData.length;
      this.unbindRoomListModal.pageCount = (this.unbindRoomListModal.count % this.unbindRoomListModal.filterData.length) == 0 ? (this.unbindRoomListModal.count / this.unbindRoomListModal.filterData.length) : (this.unbindRoomListModal.count / this.unbindRoomListModal.filterData.length + 1)
      this.displayUnbindRoomList();
      this.unbindRoomListModal.loading = false;

      this.$nextTick(() => {
        this.selectedChange();
      })
    },
    // 前端筛选
    filterModalDataWithKeyword() {
      let self = this;
      return this.unbindRoomListModal.data.filter(function (room){
        let result = false;
        for (let itemKey in room) {
          if (self.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + room[itemKey];
          if (queryItem.toUpperCase().indexOf((self.unbindRoomListModal.keyword).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'businessTime':
        case 'bedDescribe':
        case 'createDate':
        case 'custRoomAddr':
        case 'defaultPrice':
        case 'district':
        case 'modiDate':
        case 'sort':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    // 单行选择
    selectedChangeWithRow() {
      let length = Object.keys(this.$refs.unbindRoomListModalTable.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.unbindRoomListModalTable.objData[i].roomId;
        let isChecked = this.$refs.unbindRoomListModalTable.objData[i]._isChecked;
        if (!isChecked&&this.unbindRoomListModal.selectedRoomType.has(roomId)) {
          this.unbindRoomListModal.selectedRoomType.delete(roomId);
        } else if (isChecked&&!this.unbindRoomListModal.selectedRoomType.has(roomId)) {
          this.unbindRoomListModal.selectedRoomType.add(roomId);
        }
      }
      
      this.updateModalSelectedRoomType();
    },
    // 选择全部
    selectedAll() {
      for (let i=0; i<this.unbindRoomListModal.filterData.length; i++) {
        this.unbindRoomListModal.selectedRoomType.add(this.unbindRoomListModal.filterData[i].roomId);
      }
      this.selectedChange();
    },
    // 反选
    antiSelected() {
      for (let i=0; i<this.unbindRoomListModal.filterData.length; i++) {
        let roomId = this.unbindRoomListModal.filterData[i].roomId;
        if (this.unbindRoomListModal.selectedRoomType.has(roomId)) {
          this.unbindRoomListModal.selectedRoomType.delete(roomId);
        } else {
          this.unbindRoomListModal.selectedRoomType.add(roomId);
        }
      }
      this.selectedChange();
    },
    // 选择后样式变化
    selectedChange() {
      let length = Object.keys(this.$refs.unbindRoomListModalTable.objData).length;
      for (let i=0; i<length; i++) {
        let roomId = this.$refs.unbindRoomListModalTable.objData[i].roomId;
        if (this.unbindRoomListModal.selectedRoomType.has(roomId)) {
          this.$refs.unbindRoomListModalTable.objData[i]._isChecked = true;
        } else {
          this.$refs.unbindRoomListModalTable.objData[i]._isChecked = false;
        }
      }
      this.updateModalSelectedRoomType();
    },
    // 更新选择未打包房间的数据
    updateModalSelectedRoomType() {
      this.unbindRoomListModal.selectedRoomType = new Set(this.unbindRoomListModal.selectedRoomType);
    },
    // 添加打包房型
    prepareAddPkgRoomType() {

    },
    changeModalPage(pageIndex) {
      this.unbindRoomListModal.page = pageIndex;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
    changeModalPageSize(pageSize) {
      this.unbindRoomListModal.page = 1;
      this.unbindRoomListModal.pageSize = pageSize;
      this.displayUnbindRoomList();

      this.$nextTick(function () {
        this.selectedChange();
      })
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/ota/tujia/roomtype-detail/packaging-list.vue